import React, { FC } from 'react';

import { Table } from 'react-bootstrap';
import classNames from 'classnames';
import styles from '../../assets/simple-table.module.scss';
import SimpleColumn from './SimpleColumn';
//import Pagination from './Pagination';

interface Props {
    columns: { id: string; label: any; type?: string; cellStyle: string }[];
    data: { [key: string]: any }[];
    action?: (val: any) => void;
    getData?: (val: any) => void;
    pagination?: any;
    noAuto?: boolean;
    classNameTable?: string;
}

const SimpleTable: FC<Props> = ({ columns, data, action, pagination, getData, noAuto, classNameTable }: Props) => {
    return (
        <div>
            <Table
                className={classNameTable}
                style={{ display: 'block', overflowX: noAuto ? undefined : 'auto', border: 'none' }}
                striped
                bordered
                hover
            >
                <thead>
                    <tr>
                        {columns.map((column: { label: string; id: string; type?: string; cellStyle: string }, k) => (
                            <th key={`th-${k}`} className={classNames(styles[column.cellStyle])}>
                                {column.label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data &&
                        data.map((row: any, k) => {
                            if (row && row.ColumnForm) {
                                return (
                                    <row.ColumnForm
                                        action={action ? action : (val: any) => false}
                                        key={`ke${k}`}
                                        columns={columns}
                                        row={row}
                                    />
                                );
                            } else {
                                return (
                                    <SimpleColumn
                                        colorColumn={row?.colorColumn}
                                        key={`ke${k}`}
                                        columns={columns}
                                        row={row}
                                    />
                                );
                            }
                        })}
                </tbody>
            </Table>
        </div>
    );
};

export default SimpleTable;
